import { type FetchCumulativeLimitsParams, type FetchLimitLedgerRemainingParams } from '@capsicum/common';

import { walletApi } from '.';

export async function fetchLimitLedgerRemaining(params: FetchLimitLedgerRemainingParams) {
	return (await walletApi).fetchLimitLedgerRemaining(params).then(res => res.data);
}

export async function fetchCumulativeLimits(params?: FetchCumulativeLimitsParams) {
	return (await walletApi).fetchCumulativeLimits(params || {}).then(res => res.data);
}
